import React from 'react';
import BundleOption from './BundleOption';

import Classes from './BundleSelect.module.scss';

type BundleSelectProps = {
  children: React.ReactElement<typeof BundleOption>[];
};
const BundleSelect = ({ children }: BundleSelectProps) => (
  <div className={Classes.root}>
    {children.map((child, index) => (
      <div key={`bundle-select-${index}`} className={Classes.option}>
        {child}
      </div>
    ))}
  </div>
);

export default BundleSelect;
